import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { api } from "src/shared/setup/API/api";

export const UseBalancesHome = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterHome, setValuesCardsBalancesHome } = useMetricsContext();

  const handleSubmit = () => {
    api
      .get(
        `/metrics/balances?start_date=${filterHome.startDate}
        &end_date=${filterHome.endDate}
        &is_received=TRUE`
      )
      .then(({ data }) => setValuesCardsBalancesHome(data.data))
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { handleSubmit };
};
